<app-input
  [placeholder]="placeholder"
  [leftIcon]="leftIcon"
  [rightIcon]="rightIcon"
  [ngModel]="value"
  (ngModelChange)="onInputChange($event)"
  [label]="label"
  [required]="required"
  [errorMessage]="errorMessage"
  [touched]="touched"
></app-input>
